export function isConstituentAllowedToUseByLicense(constituentLicense) {
    if (constituentLicense.isIncludedInLicense) {
        return true;
    }
    switch (constituentLicense.trial.state) {
        case 'ACTIVE':
        case 'ENDED':
        case 'AVAILABLE':
            return true;
        default:
            return false;
    }
}
